import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";

async function initMixin() {
    let env=process.env.CURRENT_MODE;
    let version=process.env.VERSION;
    // 是否是生产环境
    if (env != 'dev') {
        Sentry.init({
            dsn: "https://12291e30a9cf4c78a8aee74ca40a5055@sentry.cmbi.info/61",
            integrations: [new Integrations.Vue({ Vue, attachProps: true })],
            release: `${env}@${version}`, // 代码的版本号 release 版本号
            environment: env,
            ignoreErrors: [
                'TypeError: Failed to fetch',
                'TypeError: Load failed',
                'TypeError: NetworkError when attempting to fetch resource.'
            ]
        });

        Raven.config("https://12291e30a9cf4c78a8aee74ca40a5055@sentry.cmbi.info/61")
            .addPlugin(RavenVue, Vue)
            .install();
    }

    Vue.mixin({
        data() {
            return { Sentry };
        },
        methods: {
            /**
             * 设置sentry 面包屑信息
             * @param {*} category 错误分类名称
             * @param {*} message 错误信息
             * @param {*} level 错误等级 fatal，error，warning，info，debug
             */
            setBreadcurumbs(category, message, level) {
                Sentry.addBreadcrumb({
                    category,
                    message,
                    level
                });
            },
            /**
             * 设置sentry 上下文信息
             * @param {*} key 上下文key
             * @param {*} value 上下文value
             */
            setExtra(key, value) {
                Sentry.withScope((scope) => {
                    scope.setExtra(key, value);
                    Sentry.captureException(key);
                });
            },
            /**
             * 设置sentry tags值
             * @param {*} key tags key
             * @param {*} value tags value
             */
            setTags(key, value) {
                Sentry.withScope((scope) => {
                    scope.setTag(key, value);
                });
            },
            /**
             * 设置user信息
             * @param {*} args user message 接收一个对象
             * args = {
                id: 'myid',
                name: 'myname'
                };
             */
            setUser(args) {
                Sentry.setUser(args);
            },
        }
    });
};

export { initMixin, Sentry };
